import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var generateStyle = function generateStyle(componentTheme, props) {
  var tableContainerStyles = props.tableContainerStyles || {
    width: 'calc(25% + 350px)',
    maxWidth: '100%'
  };
  return {
    tableWrapper: {
      display: 'flex',
      flexBasis: '100%',
      flexDirection: 'column',
      paddingBottom: componentTheme.tableBottomPadding
    },
    tableWidthMax: {},
    tableContainer: _objectSpread(_objectSpread({}, tableContainerStyles), {}, {
      table: {
        borderCollapse: 'separate',
        borderSpacing: '0 1px'
      },
      'table tbody tr td:': {
        width: '33.33%'
      },
      'table tbody tr th': {
        fontWeight: '400',
        width: '33.33%'
      }
    }),
    headerGrayBottomBorder: {
      'table thead tr th': {
        borderBottom: "solid 0.0625rem ".concat(componentTheme.colorGray)
      },
      'table thead tr td': {
        borderBottom: "solid 0.0625rem ".concat(componentTheme.colorGray)
      }
    },
    iconWrapper: {
      display: 'flex',
      height: '100%',
      minHeight: '47px',
      width: '46px',
      justifyContent: 'center',
      alignItems: 'center'
    },
    iconCorrect: {
      backgroundColor: componentTheme.colorGreen,
      svg: {
        fill: 'white'
      }
    },
    textContainer: {
      height: 'calc(100% - 4px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    firstTextContainer: {
      padding: componentTheme.cellPadding
    },
    incorrectRow: {
      td: {
        borderBottom: "solid 0.0625rem ".concat(componentTheme.colorGray)
      },
      th: {
        borderBottom: "solid 0.0625rem ".concat(componentTheme.colorGray)
      }
    },
    correctRow: {
      td: {
        borderStyle: 'solid',
        borderWidth: '2px 0 2px 0',
        borderColor: componentTheme.colorGreen
      },
      th: {
        border: 0
      },
      thFirstChild: {
        borderStyle: 'solid',
        borderRadius: '4px 0 0 4px',
        borderWidth: '2px 0 2px 2px',
        borderColor: componentTheme.colorGreen
      },
      tdLastChild: {
        borderStyle: 'solid',
        borderWidth: '2px 2px 2px 0',
        borderRadius: '0 4px 4px 0',
        borderColor: componentTheme.colorGreen
      }
    }
  };
};
export default generateStyle;